import { globalMessagesInitialState, type GlobalMessagesStore } from "~/features/toasts/redux/types";
import { ADD_MSG, CLEAR_MSG, DISSMISS_MSG, type GlobalMessageActions, SET_MSG } from "~/features/toasts/redux/actions";

export const globalMessagesReducer = (
  state = globalMessagesInitialState,
  action: GlobalMessageActions,
): GlobalMessagesStore => {
  switch (action.type) {
    case ADD_MSG: {
      return state.concat(action.payload);
    }

    case SET_MSG: {
      return [...action.payload];
    }

    case DISSMISS_MSG: {
      const id = action.payload;
      return state.filter((msg) => msg.id !== id);
    }

    case CLEAR_MSG: {
      return [];
    }

    default:
      return state;
  }
};
